import React, {useEffect, useState} from "react";
import Lightbox from "./Lightbox";

export function useLightbox(data) {
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);

    // Preload adjacent images
    useEffect(() => {
        if (selectedImageIndex === null) return;

        const preloadImage = (index) => {
            if (index < 0 || index >= data.length) return;
            const img = new Image();
            img.src = data[index].imagePath;
        };

        // Preload previous and next images
        preloadImage(selectedImageIndex - 1);
        preloadImage(selectedImageIndex + 1);
    }, [selectedImageIndex, data]);

    const handleImageClick = (index) => {
        setSelectedImageIndex(index);
    };

    const handleCloseLightbox = () => {
        setSelectedImageIndex(null);
    };

    const handlePrevious = () => {
        setSelectedImageIndex((prevIndex) => (prevIndex === 0 ? data.length - 1 : prevIndex - 1));
    };

    const handleNext = () => {
        setSelectedImageIndex((prevIndex) => (prevIndex === data.length - 1 ? 0 : prevIndex + 1));
    };

    const selectedImage = selectedImageIndex !== null ? data[selectedImageIndex] : null;

    const LightboxComponent = () => (
        <Lightbox
            open={selectedImageIndex !== null}
            onClose={handleCloseLightbox}
            onPrevious={handlePrevious}
            onNext={handleNext}
            image={selectedImage?.imagePath}
            title={selectedImage?.title}
            currentIndex={selectedImageIndex}
            totalImages={data.length}
        />
    );

    return {
        handleImageClick,
        LightboxComponent,
    };
}
